import styled from '@emotion/styled';
import { Tabs } from 'antd';
import { useState } from 'react';
import {
  TitreEntity,
  TitreOptionsType,
} from '../../../../entities/titre.entity';
import type { OrderPrefill } from '../../pages/dashboard';
import { PRIMARY } from '../../../../shared/colors';
import { SearchContent } from '../SearchContent';
import { Courbes } from './components/Courbes';
import { Favoris } from './components/Favoris';
import { Movers } from './components/Movers';
import { Offres } from './components/Offres';
import { Portfolio } from './components/Porfolio';

const Container = styled.div`
  height: 100%;

  > .content {
    font-family: Poppins-R;
    width: 100%;
    height: 100%;
  }

  .ant-tabs,
  .ant-tabs-content-holder,
  .ant-tabs-content,
  .ant-tabs-tabpane {
    height: 100%;
    min-height: 0;
  }

  .ant-tabs-nav {
    height: 40px;
    margin-bottom: 0;
    border-radius: 8px 8px 0 0;
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.16), transparent 42%),
      ${PRIMARY};
  }

  .ant-tabs-content-holder {
    height: calc(100% - 40px);
    overflow: hidden;
  }

  .ant-tabs-tab {
    padding: 8px 13px;
    color: rgba(255, 255, 255, 0.78);
  }

  .monitor-label {
    margin-left: 10px;
    color: var(--mt-warning);
    font-family: Poppins-B;
    text-transform: uppercase;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--mt-warning);
  }

  .ant-tabs-nav-list {
    min-width: max-content;
  }
`;

export const Monitor = ({
  titres,
  titreOptions,
  getTitre,
}: {
  titres: TitreEntity[];
  titreOptions?: TitreOptionsType;
  getTitre: (
    b: TitreEntity,
    ope: '1' | '2',
    detUrl?: string,
    prefill?: OrderPrefill,
  ) => void;
}) => {
  const [tabIndex, setTabIndex] = useState('1');
  return (
    <Container>
      {/* <div className='top'>Monitor</div> */}

      <div className='content'>
        <Tabs
          defaultActiveKey='1'
          activeKey={tabIndex}
          type='line'
          onChange={(key: string) => setTabIndex(key)}
          size='small'
          tabBarStyle={{ margin: 0 }}
        >
          <Tabs.TabPane
            tab={<span className='monitor-label'>Suivi</span>}
            key='0'
            disabled
          >
            <p>SUIVI</p>
          </Tabs.TabPane>
          <Tabs.TabPane tab='Titres' key='1'>
            <SearchContent
              mainScreen={true}
              titresData={titres}
              titreOptions={titreOptions}
              getTitre={getTitre}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Offres' key='2'>
            <Offres titresData={titres} getTitre={getTitre} />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Portefeuille' key='3'>
            <Portfolio getTitre={getTitre} />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Favoris' key='4'>
            <Favoris getTitre={getTitre} />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Movers' key='5'>
            <Movers getTitre={getTitre} />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Courbes des taux' key='6'>
            <Courbes titresData={titres} getTitre={getTitre} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </Container>
  );
};
